<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <template-listing-item-base v-bind:id="template.Id" 
                                v-bind:name="template.Name" 
                                v-bind:date="template.Modified"
                                v-bind:can-delete="canDelete"
                                v-bind:can-edit="canEdit"
                                @template-deleted="$emit('template-deleted', $event)"
                                @template-selected="$emit('template-selected', $event)"
    >
        <template v-slot:sub-text-label="{ formattedDate }">
           {{ resource('TemplateDraftListingItem_Item_SubTextLabel') }} {{ formattedDate }}
        </template>
    </template-listing-item-base>
</template>

<script>
    import templateManagerApi from '../../../../Api/template-manager';

    import securityApi from '../../../../Util/security';

    import resourceMixin from '../../../../Util/Mixins/resources';
    
    import TemplateListingItemBase from './TemplateListingItemBase.vue';
    
    export default {
        name: "template-draft-listing-item",
        components: {
            TemplateListingItemBase
        },
        mixins: [resourceMixin],
        beforeCreate(){
            const vm = this;

            templateManagerApi.validatePermission(securityApi.PermissionGrantTypes.Write).then(
                canWrite => vm.canEdit = canWrite
            );

            templateManagerApi.validatePermission(securityApi.PermissionGrantTypes.Delete).then(
                canDelete => vm.canDelete = canDelete
            );
        },
        data: () => ({
            canDelete: false,
            canEdit: false
        }),
        props: {
            template: {
                type: Object,
                required: true,
                default() {
                    return {
                        Id: '',
                        Name: '',
                        
                        Modified: new Date()
                    }
                }
            }
        }
    };
</script>
